module.exports = __webpack_public_path__ + "img/179980.194d0c73.png";